import { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  BudgetTimelineModel,
  OrderTimelineModel,
} from '../../models/CompanyStatistics';
import { StatisticsFilterModel } from '../../models/StatisticsFilterModel';

interface ICompanyStatisticsService {
  getOrdersTimeline: (
    data: StatisticsFilterModel,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<OrderTimelineModel[]>>;
  getBudgetTimeline: (
    data: StatisticsFilterModel,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<BudgetTimelineModel>>;
}

export const companyStatisticsService: ICompanyStatisticsService = {
  getOrdersTimeline(data, axiosConfig) {
    return ajax.get<OrderTimelineModel[]>(
      `${config.benefitApiUrl}/company-statistics/orders-timeline`,
      {
        ...axiosConfig,
        params: {
          dateStart: data.dateStart
            ? moment(data.dateStart).format('YYYY-MM-DD')
            : undefined,
          dateEnd: data.dateEnd
            ? moment(data.dateEnd).format('YYYY-MM-DD')
            : undefined,
          companyId: data.companyId,
        },
      },
    );
  },
  getBudgetTimeline(data, axiosConfig) {
    return ajax.get<BudgetTimelineModel>(
      `${config.benefitApiUrl}/company-statistics/budget-timeline`,
      {
        ...axiosConfig,
        params: {
          dateStart: data.dateStart
            ? moment(data.dateStart).format('YYYY-MM-DD')
            : undefined,
          dateEnd: data.dateEnd
            ? moment(data.dateEnd).format('YYYY-MM-DD')
            : undefined,
          companyId: data.companyId,
        },
      },
    );
  },
};
